import { render } from "./ShelfTemplateProductSlider.vue?vue&type=template&id=491bbf2d&scoped=true"
import script from "./ShelfTemplateProductSlider.vue?vue&type=script&lang=js"
export * from "./ShelfTemplateProductSlider.vue?vue&type=script&lang=js"

import "@/assets/scss/_shelf.scss?vue&type=style&index=0&id=491bbf2d&lang=scss&scoped=true"
import "@/assets/scss/_carousel.scss?vue&type=style&index=1&lang=scss"
import "./ShelfTemplateProductSlider.vue?vue&type=style&index=2&id=491bbf2d&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491bbf2d"]])

export default __exports__